export enum AIAssistantActionTypes {
  GET_CONVERSATIONS = 'GET_CONVERSATIONS',
  GET_CONVERSATION_MESSAGES = 'GET_CONVERSATION_MESSAGES',
  POST_PROMPT = 'POST_PROMPT',
}